import eventNames from 'src/analytics/eventNames';
import track from 'src/analytics/track';

import { ADD_TO_HOMESCREEN_EVENT_DATA } from './eventData';

export function trackAddToHomescreenBannerAppear({ times }: { times: number }) {
  track(eventNames.module_viewed, {
    times,
    site: 'main',
    module_name: ADD_TO_HOMESCREEN_EVENT_DATA.bannerModuleName,
    flow: ADD_TO_HOMESCREEN_EVENT_DATA.flow,
  });
}
